import { useContext, useState } from "react";
import { BillingInformationContext } from "../../../BillingInformationContext";
import { createPaymentMethod, initPaymentMethodCreation, logCreatePaymentMethodEvent, } from "./PaymentMethodCreate-utils";
import { useLogging } from "../../../../../Shared/hooks/useLogging/useLogging";
export const usePaymentMethodCreate = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const { setClientSecret, setToken, setPublicKey, setCustomerCreditCards, setPaymentProcessor, customerCreditCards } = useContext(BillingInformationContext);
    const { logReactPixel, createKlaviyoEvent, gaEvent, datadogLog } = useLogging();
    return {
        initPaymentMethodCreation: initPaymentMethodCreation(setLoading, setError, setToken, setPublicKey, setClientSecret, setPaymentProcessor, datadogLog),
        createPaymentMethod: createPaymentMethod(setError, setLoading, setCustomerCreditCards, logCreatePaymentMethodEvent(logReactPixel, createKlaviyoEvent, gaEvent), datadogLog, customerCreditCards),
        loading,
        error,
    };
};
